/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Environment constants for consistent environment references across the application</blockquote>
 * 
 * @example
 * ```typescript
 * import { ENVIRONMENTS } from '@shared/utils';
 * 
 * if (currentEnv === ENVIRONMENTS.DEVELOPMENT) {
 *   // Development-specific logic
 * }
 * ```
 * 
 * Common environments:
 * - 'development': Local development environment
 * - 'preview': Preview/staging environment (Vercel preview deployments)
 * - 'production': Production environment
 */
export const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  PREVIEW: 'preview',
  PRODUCTION: 'production'
} as const; 